var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full justify-content-center align-items-center"},[_c('BaseDropdownOptionsWrapper',{attrs:{"options":_vm.options,"is-horizontal":true},on:{"select":_vm.handleDropdownSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }